export const SEAT_SYMBOL_ID = "plane-seat-shape";

const SEAT_BODY_PATH =
  "M20 0.5H44C51.4558 0.5 57.5 6.54416 57.5 14V52C57.5 55.0376 55.0376 57.5 52 57.5H12C8.96243 57.5 6.5 55.0376 6.5 52V14C6.5 6.54416 12.5442 0.500001 20 0.5Z";

export default function SeatSymbolDefs() {
  return (
    <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden focusable="false">
      <defs>
        <symbol id={SEAT_SYMBOL_ID} viewBox="0 0 64 58">
          <path d={SEAT_BODY_PATH} fill="white" stroke="none" />
          <path d={SEAT_BODY_PATH} fillOpacity="0.45" />
          <rect y="25" width="7" height="31" rx="3.5" stroke="none" />
          <rect x="57" y="25" width="7" height="31" rx="3.5" stroke="none" />
          <rect opacity="0.95" x="21" y="50" width="23" height="4" rx="2" fill="white" stroke="none" />
        </symbol>
      </defs>
    </svg>
  );
}
